import { AxiosResponse } from 'axios';

import { PaymentType } from './dto/Payments';
import BaseApi from './BaseApi';

const commonApi = {
  getPaymentTypes(): Promise<AxiosResponse<PaymentType[]>> {
    return BaseApi.get('/api/v1/common/info/payment/types');
  },
  getPaymentTokens(): Promise<AxiosResponse<any[]>> {
    return BaseApi.get('/api/v1/common/info/tokens');
  },
  getAvailablePaymentTokens(): Promise<AxiosResponse<any[]>> {
    return BaseApi.get(`/api/v1/sales/available/tokens`);
  },
};

export default commonApi;
